//游戏大厅

import React, {Component} from 'react';
import Container from '../component/container'
import PlatformCard from '../component/platformCard'
import SearchBar from '../component/searchBar'
import style from '../utils/config.scss'
import model from "../services/model";
import PublicUtils from "../utils/publicUtils";
import FloatBtn from '../component/floatBtn'
import '../assets/css/animation.css'
import global from "../global";
import Image from "../component/image";


class Games extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeItemIndex: 0
        };
    }

    componentDidMount() {

        if(global.ID == 'yy'){
            model.gameList[3].gamelist = [
                {
                    "type": 4,
                    "game_id": 402,
                    "game_api": "PG",
                    "name": "PG老虎机",
                    "imgPath": "https://newpic.hdyb33.com/games/pg.png",
                    "icon": "logo-pg",
                    "game_list_json": "PG_game_list",
                    "game_list_img_path": "/new/slot_res/pg/",
                    "memo1": "平台特色：游戏齐全赚翻天 精彩好玩别错过",
                    "memo2": "包含游戏：海贼王、捕鱼达人、时尚丽人、水果、火影忍者、蛋糕、世界之窗...",
                    "labels": "#老虎机#海贼王#捕鱼达人#时尚丽人#水果",
                    "hot_type": "hot",
                    "showTitle": 1
                },
                {
                    "type": 4,
                    "game_id": 407,
                    "game_api": "VIP",
                    "name": "VIP老虎机",
                    "imgPath": "https://newpic.hdyb33.com/games/vip.png",
                    "icon": "vip",
                    "game_list_json": "VIP_game_list",
                    "game_list_img_path": "/new/slot_res/vip/",
                    "memo1": "平台特色：游戏齐全赚翻天 精彩好玩别错过",
                    "memo2": "包含游戏：推筒子、飞禽走兽、森林舞会、斗三公、红黑梅方、疯狂德州...",
                    "labels": "#老虎机#推筒子#飞禽走兽#森林舞会#斗三公",
                    "hot_type": "hot",
                    "showTitle": 1
                },
                {
                    "type": 4,
                    "game_id": 411,
                    "game_api": "FG",
                    "name": "FG老虎机",
                    "imgPath": "https://newpic.hdyb33.com/games/pg.png",
                    "icon": "fg",
                    "game_list_json": "FG_game_list",
                    "game_list_img_path": "/new/slot_res/fg/",
                    "memo1": "平台特色：游戏齐全赚翻天 精彩好玩别错过",
                    "memo2": "包含游戏：变形金刚、淘金热、66路、狂欢、埃及、接头霸王、东方国度、西部牛仔..",
                    "labels": "#老虎机#变形金刚#淘金热#66路#狂欢#埃及#接头霸王#东方国度#西部牛仔"
                },
                {
                    "type": 4,
                    "game_id": 414,
                    "game_api": "HCDZ",
                    "name": "GB老虎机",
                    "imgPath": "https://newpic.hdyb33.com/games/hcdz.png",
                    "icon": "logo-hcdz",
                    "game_list_json": "HCDZ_game_list",
                    "game_list_img_path": "/new/slot_res/hcdz/",
                    "memo1": "平台特色：游戏齐全赚翻天 精彩好玩别错过",
                    "memo2": "包含游戏：富贵吉祥,爆骰,鱼虾蟹,糖果世界,宝石大亨,欢乐地鼠,齐天大圣,圣域传说",
                    "labels": ""
                },
                {
                    "type": 4,
                    "game_id": 415,
                    "game_api": "PP",
                    "name": "PP老虎机",
                    "imgPath": "https://newpic.hdyb33.com/games/pp.png",
                    "icon": "logo-pp",
                    "game_list_json": "PP_game_list",
                    "game_list_img_path": "/new/slot_res/pp/",
                    "memo1": "平台特色：游戏齐全赚翻天 精彩好玩别错过",
                    "memo2": "包含游戏：富贵吉祥,爆骰,鱼虾蟹,糖果世界,宝石大亨,欢乐地鼠,齐天大圣,圣域传说",
                    "labels": ""
                },
                {
                    "type": 4,
                    "game_id": 406,
                    "game_api": "CQ9",
                    "name": "CQ9老虎机",
                    "imgPath": "https://newpic.hdyb33.com/games/cq9.png",
                    "icon": "cq9",
                    "game_list_json": "CQ9_game_list",
                    "game_list_img_path": "/new/slot_res/cq9/",
                    "memo1": "平台特色：游戏齐全赚翻天 精彩好玩别错过",
                    "memo2": "包含游戏：盗法老墓、妙笔生财、喵财进宝、鱼跃龙门、丛林宝藏、喵喵、老司机...",
                    "labels": "#老虎机#盗法老墓#妙笔生财#喵财进宝#鱼跃龙门"
                },
                {
                    "type": 4,
                    "game_id": 403,
                    "game_api": "HB",
                    "name": "HB老虎机",
                    "imgPath": "https://newpic.hdyb33.com/games/hb.png",
                    "icon": "hb",
                    "game_list_json": "HB_game_list",
                    "game_list_img_path": "/new/slot_res/hb/",
                    "memo1": "平台特色：游戏齐全赚翻天 精彩好玩别错过",
                    "memo2": "包含游戏：欢乐喜狮、疯狂水果、快乐圣诞、快乐南瓜、神秘埃及、寻宝记...",
                    "labels": "#老虎机#欢乐喜狮#疯狂水果#快乐圣诞#快乐南瓜"
                },
                {
                    "type": 4,
                    "game_id": 409,
                    "game_api": "MG",
                    "name": "MG老虎机",
                    "imgPath": "https://newpic.hdyb33.com/games/mg.png",
                    "icon": "logo-mg",
                    "game_list_json": "MG_game_list",
                    "game_list_img_path": "/new/slot_res/mg/",
                    "memo1": "平台特色：游戏齐全赚翻天 精彩好玩别错过",
                    "memo2": "包含游戏：108好汉、亚洲美人、大逃杀、冒险宫殿、靶心、抢劫银行、欢乐节、昆虫派对...",
                    "labels": "#老虎机#108好汉#亚洲美人#大逃杀#冒险宫殿#靶心#抢劫银行#欢乐节#昆虫派对"
                },
                {
                    "type": 4,
                    "game_id": 405,
                    "game_api": "MW",
                    "name": "MW老虎机",
                    "imgPath": "https://newpic.hdyb33.com/games/mw.png",
                    "icon": "mw",
                    "game_list_json": "MW_game_list",
                    "game_list_img_path": "/new/slot_res/mw/",
                    "memo1": "平台特色：游戏齐全赚翻天 精彩好玩别错过",
                    "memo2": "包含游戏：活动专区、千炮捕鱼、水浒传、蜜糖甜心、百家乐、五路财神...",
                    "labels": "#老虎机#活动专区#千炮捕鱼#水浒传#蜜糖甜心"
                },

                {
                    "type": 4,
                    "game_id": 404,
                    "game_api": "SG",
                    "name": "SG老虎机",
                    "imgPath": "https://newpic.hdyb33.com/games/sg.png",
                    "icon": "sg",
                    "game_list_json": "SG_game_list",
                    "game_list_img_path": "/new/slot_res/sg/",
                    "memo1": "平台特色：游戏齐全赚翻天 精彩好玩别错过",
                    "memo2": "包含游戏：捕鱼大王、朱大富、四大财神、糖果泡泡、金武门、斧头帮、初恋、海龙王...",
                    "labels": "#老虎机#捕鱼大王#朱大富#四大财神#糖果泡泡"
                }
            ]

        }

    }

    componentWillUnmount() {
    }

    render() {
        const styles = {
            container: {
                display: "flex",
                flex: 1,
                flexDirection: "column",
            },
            searchBarBox: {
                display: "flex",
                paddingTop: 20,
                paddingLeft: 10,
                paddingRight: 10,
                backgroundColor: "#fff",
                flexDirection: "column",
            },
            topContainer: {
                display: "flex",
                flexDirection: "row",
                backgroundColor: "#fff"
                // borderBottomWidth: 1,
                // borderBottomColor: "#f1f1f1"
            },
            bottomContainer: {
                display: "flex",
                flexDirection: "column",
            },
            gameTitle: {
                display: "flex",
                flex: 1,
                height: 50,
                paddingLeft: 10,
                paddingRight: 5,
                justifyContent: 'center',
                alignItems: 'center',
            },
            gameActiveTitle: {
                // borderBottomWidth: 1,
                // borderBottomColor: style['primaryColor' + model.SKINNAME]
            },
            gameTitleText: {
                fontSize: 16
            },
            gameActiveTitleText: {
                color: style['primaryColor' + model.SKINNAME],
                fontWeight: 'bold'
            },


            gameBox: {
                paddingLeft: 10,
                backgroundColor: "#fff",
                display: "flex"
            },
            gameInnerBox: {
                flex: 1,
                display: "flex",
                flexDirection: "row",
                borderBottom: "1px solid " + style['backgrountColor' + model.SKINNAME],
                paddingTop: 10,
                paddingBottom: 10,
                overflow: "hidden"
            },

            gameIconBox: {
                display: "flex",
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
            },
            gameIcon: {
                display: "flex",
                width: 60,
                height: 60,
                backgroundColor: style['primaryColor' + model.SKINNAME],
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: 3
            },

            gameInfo: {
                marginTop: 5,
                flex: 1,
                display: "flex",
                fontSize: 12,
                color: "#999",
                lineHeight: "17px",
            },

            gameDetailBox: {
                display: "flex",
                flex: 1,
                flexDirection: "column",
                marginLeft: 10,
                paddingRight: 10,
                width: 0
            },
            gameInfoTextBox: {
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                overflow: "hidden",
            },
        };
        return (
            <Container tabIndex={2} showBottomTab={true} showHeader={false} style={{backgroundColor: "#fff"}}>
                <div style={styles.container}>
                    <div className={'headPadding'}>
                        <div style={{...styles.searchBarBox, ...{backgroundColor: "#fff"}}}>
                            <SearchBar onPress={() => {
                                PublicUtils.navigate('SearchView');
                            }}/>
                        </div>
                    </div>
                    <div style={styles.topContainer}>
                        {model.gameList.map((item, i) => {
                            return (item.name && item.type_id != 8) ? <div key={item.name} onClick={(item) => {
                                this.setState({activeItemIndex: i});
                            }}
                                                                           style={{...styles.gameTitle, ...i === this.state.activeItemIndex ? styles.gameActiveTitle : null}}>
                                <div
                                    style={{...styles.gameTitleText, ...i === this.state.activeItemIndex ? styles.gameActiveTitleText : null}}>{item.name}</div>
                            </div> : null
                        })}
                    </div>
                    <div style={{backgroundColor: "#f1f1f1", flex: 1, height: 10}}/>





                    {this.state.activeItemIndex == 1 && global.ID== 'ar' || this.state.activeItemIndex == 1 && global.ID== 'bw' || this.state.activeItemIndex == 1 && global.ID== 'br' || this.state.activeItemIndex == 1 && global.ID== 'ct'?<div>

                        <div onClick={() => {

                            let parm = {
                                "id": 1001,
                                "is_name": "香港六合彩",
                                "is_function": "lhc",
                                "is_number": 0,
                                "is_status": 2,
                                "is_img": "lhc",
                                "tmp": "LHC"
                            }

                          model.isgl = [parm];
                          model.isid = parm.id;
                            PublicUtils.navigate('LHC', parm);


                        }} style={styles.gameBox}>
                            <div style={styles.gameInnerBox}>
                                <div style={styles.gameIconBox}>
                                    <div style={styles.gameIcon}>
                                        <Image style={{width: 30}} resizeMode='contain'
                                               uri={'https://newpic.hdyb33.com/bw/lhc-xg.png'}/>
                                    </div>
                                </div>
                                <div style={styles.gameDetailBox}>
                                    <div style={styles.gameName}>
                                       香港六合彩
                                    </div>

                                    <div style={styles.gameInfo}>
                                        <div
                                          style={styles.gameInfoTextBox}></div>
                                    </div>
                                </div>
                            </div>
                        </div>





                      <div onClick={() => {

                        let parm = {
                          "id": 10015,
                          "is_name": "澳门六合彩(新)",
                          "is_function": "lhc",
                          "is_number": 1,
                          "is_status": 1,
                          "is_img": "amlhc",
                          "tmp": "LHC"
                        }

                        model.isgl = [parm];
                        model.isid = parm.id;


                        PublicUtils.navigate('LHC', parm);


                      }} style={styles.gameBox}>
                        <div style={styles.gameInnerBox}>
                          <div style={styles.gameIconBox}>
                            <div style={styles.gameIcon}>
                              <Image style={{width: 30}} resizeMode='contain'
                                     uri={'https://newpic.hdyb33.com/bw/lhc-am.png'}/>
                            </div>
                          </div>
                          <div style={styles.gameDetailBox}>
                            <div style={styles.gameName}>
                              澳门六合彩(新)
                            </div>
                            <div style={styles.gameInfo}>
                              <div
                                  style={styles.gameInfoTextBox}></div>
                            </div>
                          </div>
                        </div>
                      </div>


                    </div>:<div></div>}

                    <div style={styles.bottomContainer}>
                        {
                            model.gameList[this.state.activeItemIndex].gamelist.map((item, key) => {
                                return <PlatformCard key={key} obj={item} icon={item.icon} name={item.name} isix={this.state.activeItemIndex}
                                                     memo1={item.memo1}
                                                     memo2={item.memo2}/>
                            })
                        }
                    </div>
                </div>
                {/**/}
                <FloatBtn/>
            </Container>
        )
    }
}

export default Games;
